import React, { useState } from "react";
import { MdOutlineThumbUp, MdOutlineThumbDown, MdSync } from "react-icons/md";
import { FeedbackButton, FeedbackButtonsWrapper, FeedbackContainer, secondaryAltColor, secondaryColor } from "./FAQSearch.style";

export const ChatMessageWithFeedback = ({ msg, msgIndex, onFeedback, chatContainerRef }) => {
    // msg.role === 'assistant'
    const [feedback, setFeedback] = useState(null); 
    // feedback can be 'up', 'down', 'regenerate' or null
  
    const handleFeedback = (type) => {
      // Allow regenerate even if feedback is already set (thumbs up/down)
      // But prevent thumbs up/down from being clicked again
      if (feedback && type !== 'regenerate') return;
      
      // For regenerate, don't update the feedback state (keep existing thumbs up/down state)
      if (type !== 'regenerate') {
        setFeedback(type);
      }
      
      // Auto-scroll chat container to bottom after feedback (without shifting page)
      setTimeout(() => {
        if (chatContainerRef?.current) {
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
      }, 100);
      
      // send to backend
      onFeedback({ 
        messageIndex: msgIndex, 
        messageContent: msg.content,
        feedbackType: type,
        timestamp: new Date().toISOString()
      });
    };
  
    return (
      <FeedbackContainer>
        {msg.role === 'assistant' && (
          <FeedbackButtonsWrapper>
            <span style={{ fontSize: '0.72rem', color: '#6b7280', marginRight: '0.25rem', alignSelf: 'center' }}>
              How helpful was this?
            </span>
            <FeedbackButton 
              size="small" 
              feedbackActive={feedback==="up"}
              disabled={!!feedback} 
              onClick={() => handleFeedback('up')}
              color={feedback === 'down' ? "error" : "default"}
            >
              <MdOutlineThumbUp color={feedback==="up"?secondaryAltColor:secondaryColor} />
            </FeedbackButton>
            <FeedbackButton 
              size="small" 
              feedbackActive={feedback==="down"}
              disabled={!!feedback} 
              onClick={() => handleFeedback('down')}
              color={feedback === 'down' ? "error" : "default"}
            >
              <MdOutlineThumbDown  color={feedback==="down"?secondaryAltColor:secondaryColor}/>
            </FeedbackButton>
            <FeedbackButton 
              size="small" 
              feedbackActive={feedback==="regenerate"}
              onClick={() => handleFeedback('regenerate')}
              color={feedback === 'regenerate' ? "secondary" : "default"}
            >
                <MdSync color={feedback==="regenerate"?secondaryAltColor:secondaryColor}/>
            </FeedbackButton>
          </FeedbackButtonsWrapper>
        )}
      </FeedbackContainer>
    );
  };